import { employeeCertificates } from '../employeeCertificate'
import { describeTable } from './describeTable'

describeTable(employeeCertificates, {
  description: `A certificate (e.g. tulityökortti, työturvallisuuskortti, nuohoojan ammattitutkinto) held by an employee, with its validity window. Join certificates for the name. A certificate is current when valid_from <= today and (valid_until IS NULL OR valid_until >= today); an expired one is a compliance finding, not a deleted row.
The scanned card/photo is an attachments row with entity_type = 'employeeCertificate' and entity_id = this row's id.`,
  columns: {
    validFrom: 'First valid day; NULL when unknown.',
    validUntil: 'Expiry day; NULL = does not expire.',
  },
})
